"use strict";

// Copyright 2012-2020 The MathWorks, Inc.
define(['dojo/_base/declare', 'dojo/_base/xhr', 'dojo/_base/lang', 'mw-remote/RemoteEndPointsManager', './Transaction'], function (declare, xhr, lang, RemoteEndPointsManager, Transaction) {
  return declare(Transaction, {
    constructor: function constructor(args) {
      args = args || {};
      this.uuid = args.uuid || this._generateUuid();
    },

    /**
     * Convert the request messages into a JSON string representation. The request message
     * constructed is different for message container based endPoints Vs Non MessaageContainer
     * based endPoints.
     */
    _getRequest: function _getRequest(messages) {
      var isMessageContainerBased = RemoteEndPointsManager.isEndpointMessageContainerBased(this.endPointName);
      var request = null;

      if (isMessageContainerBased) {
        request = {
          uuid: this.uuid,
          messages: messages
        };

        if (this.computeToken) {
          request.computeToken = this.computeToken;
        }
      } else {
        var keys = Object.keys(messages);
        keys.forEach(function (key) {
          request = messages[key];
        });
      }

      this._sanitizeForJson(request);

      return JSON.stringify(request, null, 0);
    },
    _sanitizeForJson: function _sanitizeForJson(data) {
      var key;

      if (lang.isArray(data)) {
        data.forEach(this._sanitizeForJson, this);
      } else if (lang.isObject(data)) {
        for (key in data) {
          if (data.hasOwnProperty(key)) {
            if (data[key] === undefined) {
              delete data[key];
            } else if (lang.isObject(data[key]) || lang.isArray(data[key])) {
              this._sanitizeForJson(data[key]);
            }
          }
        }
      }
    },

    /**
     * Private function to make the actual XHR request.
     * @param data String data in JSON format.
     * @return Deferred representing the XHR request.
     */
    _doSend: function _doSend(data) {
      return xhr.post({
        url: this._getEndpoint(),
        // set the content type to json so that chrome
        // knows how to display it properly. the server ignores this.
        contentType: 'application/json',
        handleAs: 'json',
        // todo: Determine a way to handle message level timeouts. Some requests need to be
        // unbounded, but not all of them.
        // timeout: 10000,
        postData: data
      });
    },

    /**
     * Process the response object for any faults or faults.
     * @param response Object from the server (already converted from JSON into an Object).
     */
    _processResponse: function _processResponse(response) {
      this.stopTime = new Date().getTime();

      if (!response) {
        this.fault = {
          faultCode: 'Connection.Fault',
          message: 'Unable to communicate with server, no response.'
        };
      } else {
        if (response.fault) {
          this.fault = response.fault;
        }
        /**
         * For non-message container based messages like UDR, response structure does not
         * have messages bundled.
         */


        if (response.messages) {
          this.responseMessages = response.messages;
        } else {
          this.responseMessages = response;
        }
      }
    },

    /**
     * Add the fault to the fault property.
     * @param fault Remote connection fault.
     */
    _processFault: function _processFault(fault) {
      this.stopTime = new Date().getTime();
      this.fault = {
        faultCode: 'Connection.Fault',
        message: fault
      };
    }
  });
});
//# sourceMappingURL=JsonTransaction.js.map
